export default __webpack_public_path__ + "static/media/information--minimum-speed-25--g1.4db75e5c.png";